var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: { title: "新增苗场对客户经理的认可关系", width: 60 },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm.$globalSpin
        ? _c("Spin", { attrs: { size: "large", fix: "" } })
        : _vm._e(),
      _c(
        "Form",
        {
          ref: "modelForm",
          staticClass: "small-form",
          attrs: {
            model: _vm.modelForm,
            rules: _vm.ruleValidate,
            "label-position": "top",
          },
        },
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: "选择客户经理",
                        prop: "userCustomerManagerUuid",
                      },
                    },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { filterable: "" },
                          model: {
                            value: _vm.modelForm.userCustomerManagerUuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.modelForm,
                                "userCustomerManagerUuid",
                                $$v
                              )
                            },
                            expression: "modelForm.userCustomerManagerUuid",
                          },
                        },
                        _vm._l(_vm.userCustomerManagerList, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.userCustomerManagerLoginUuid,
                              attrs: {
                                value: item.userCustomerManagerLoginUuid,
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(item.userCustomerManagerName) +
                                  "\n\t\t\t\t\t"
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "是否认可", prop: "recordStatus" } },
                    [
                      _c(
                        "RadioGroup",
                        {
                          attrs: { type: "button" },
                          model: {
                            value: _vm.modelForm.recordStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.modelForm, "recordStatus", $$v)
                            },
                            expression: "modelForm.recordStatus",
                          },
                        },
                        _vm._l(_vm.statusSource, function (item) {
                          return _c(
                            "Radio",
                            { key: item.val, attrs: { label: item.val } },
                            [_vm._v(_vm._s(item.label) + "\n\t\t\t\t\t")]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "Button",
            { attrs: { type: "primary" }, on: { click: _vm.onSave } },
            [_vm._v("确认")]
          ),
          _c(
            "Button",
            { attrs: { type: "error" }, on: { click: _vm.onCancel } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }